import axios from "axios";
export async function fetchData(url, pastYears, archive, mandatoryTopics) {
    try {
        const response = await axios.get(url);
        const data = filterMandatoryTopics(response.data, mandatoryTopics);
        debugger;
        return getData(data, pastYears, archive);
    }
    catch (error) {
        console.error("Data fetch error", error);
        return null;
    }
}
function filterMandatoryTopics(data, mandatoryTopics) {
    if (mandatoryTopics?.length) {
        const mandatoryTopicIds = new Set(mandatoryTopics.map(t => t.id));
        return data.filter(item => item.topics?.some(topic => mandatoryTopicIds.has(topic)));
    }
    return data;
}
/**
 * Algorithms
 * 1. Only new events: >= now filter
 * 2. All events: no filter
 * 3. Only archive events: < now filter
 */
function getData(data, pastYears, archive) {
    if (archive) {
        return getArchiveData(data);
    }
    else if (!pastYears) {
        return getNewData(data);
    }
    else {
        return getAllData(data);
    }
}
// Only archive events
function getArchiveData(data) {
    const now = new Date();
    const filteredData = data.filter(item => {
        const itemStartDate = new Date(item.date);
        return itemStartDate < now;
    });
    return orderData(filteredData, 'desc');
}
// Only new events or news, pastYears = false
function getNewData(data) {
    const now = new Date();
    const filteredData = data.filter(item => {
        const itemStartDate = new Date(Date.parse(item.date));
        const itemEndDate = item.dateEnd ? new Date(Date.parse(item.dateEnd)) : null;
        if (itemEndDate && itemStartDate !== itemEndDate) {
            return (itemStartDate >= now || itemEndDate >= now);
        }
        return itemStartDate >= now;
    });
    return orderData(filteredData, 'asc');
}
function getAllData(data) {
    return orderData(data, 'desc');
}
/**
 * 1. Archive = desc
 * 2. only new data = asc
 * 3. all data desc
 */
function orderData(items, order) {
    return items.sort((a, b) => {
        const dateA = new Date(Date.parse(a.date)).getTime();
        const dateB = new Date(Date.parse(b.date)).getTime();
        if (order === 'asc') {
            // (small to big)
            return dateA - dateB;
        }
        else {
            // (big to small)
            return dateB - dateA;
        }
    });
}
